var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    { staticClass: "fill", attrs: { "title-color": "primary" } },
    [
      _c("b-container", { attrs: { fluid: "" } }, [
        _c("form", { attrs: { "data-vv-scope": "data-user" } }, [
          _c("h3", [_vm._v("Solicitud de Materiales")]),
          _c("div", { staticClass: "row mt-3" }, [
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c("label", [_vm._v("Fecha de Solicitud:")]),
                _c("b-form-datepicker", {
                  attrs: {
                    id: "datepicker-request",
                    locale: "es",
                    placeholder: "Elige una fecha",
                    size: "md",
                    min: _vm.minDate
                  },
                  model: {
                    value: _vm.userData.dateRequest,
                    callback: function($$v) {
                      _vm.$set(_vm.userData, "dateRequest", $$v)
                    },
                    expression: "userData.dateRequest"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c("label", [_vm._v("Fecha de Retiro:")]),
                _c("b-form-datepicker", {
                  attrs: {
                    id: "datepicker-request-end",
                    locale: "es",
                    placeholder: "Elige una fecha",
                    size: "md",
                    min: _vm.minDate
                  },
                  model: {
                    value: _vm.userData.dateRequestEnd,
                    callback: function($$v) {
                      _vm.$set(_vm.userData, "dateRequestEnd", $$v)
                    },
                    expression: "userData.dateRequestEnd"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row mt-3", attrs: { id: "user-list" } }, [
            _c(
              "div",
              { staticClass: "col-4" },
              [
                _c("label", [_vm._v("Nombre Solicitud:")]),
                _c("b-form-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    placeholder: "Ingresa Solicitud",
                    size: "md",
                    name: "request",
                    state: _vm.errors.has("data-user.request") ? false : null
                  },
                  model: {
                    value: _vm.userData.request,
                    callback: function($$v) {
                      _vm.$set(_vm.userData, "request", $$v)
                    },
                    expression: "userData.request"
                  }
                }),
                _c("b-form-invalid-feedback", [
                  _vm._v(
                    " " + _vm._s(_vm.errors.first("data-user.request")) + " "
                  )
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-8" },
              [
                _c("label", [_vm._v("Descripción:")]),
                _c("b-form-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  attrs: {
                    placeholder: "Descripcion",
                    size: "md",
                    name: "description",
                    state: _vm.errors.has("data-user.description")
                      ? false
                      : null
                  },
                  model: {
                    value: _vm.userData.description,
                    callback: function($$v) {
                      _vm.$set(_vm.userData, "description", $$v)
                    },
                    expression: "userData.description"
                  }
                }),
                _c("b-form-invalid-feedback", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.errors.first("data-user.description")) +
                      " "
                  )
                ])
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row mt-3" }, [
            _vm.isLoadOptionList
              ? _c(
                  "div",
                  { staticClass: "col-4 demo-inline-spacing" },
                  [
                    _c("b-spinner", {
                      key: "primary",
                      attrs: { variant: "primary" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isLoadOptionList
              ? _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("label", [_vm._v("Entidad:")]),
                    _c("OptionList", {
                      on: { "select-item": _vm.getChildrenEntities }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "col-8" }, [
              _c("label", [_vm._v("Entidad Hija:")]),
              _c(
                "div",
                { staticClass: "children-entities" },
                [
                  _vm.isLoadOptionChildrenList
                    ? _c(
                        "div",
                        { staticClass: "row mt-3" },
                        [
                          _c("b-spinner", {
                            key: "primary",
                            staticClass: "ml-5 mt-3",
                            attrs: { variant: "primary" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isLoadOptionChildrenList
                    ? _c("b-form-checkbox-group", {
                        staticClass: "mt-3",
                        attrs: {
                          id: "checkbox-group-children-entities",
                          name: "flavour-2",
                          options: _vm.childrenEntities,
                          "value-field": "entity",
                          "text-field": "entity.name"
                        },
                        model: {
                          value: _vm.selectedEntities,
                          callback: function($$v) {
                            _vm.selectedEntities = $$v
                          },
                          expression: "selectedEntities"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ]),
          _c("br"),
          _c("br"),
          _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-8" }, [
              _c("h3", [_vm._v("Materiales")]),
              !_vm.enableMaterialsTable
                ? _c("span", { staticClass: "font-medium-1 text-primary" }, [
                    _vm._v(
                      " Debes seleccionar al menos una entidad hija para continuar "
                    )
                  ])
                : _vm._e()
            ]),
            _vm.enableMaterialsTable
              ? _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c(
                      "vs-dropdown",
                      {
                        staticClass: "dropdown-option-menu",
                        attrs: { "vs-trigger-click": "" }
                      },
                      [
                        _c(
                          "vs-chip",
                          { attrs: { color: "primary" } },
                          [
                            _c("vs-avatar", {
                              attrs: { color: "primary", icon: "add" }
                            }),
                            _vm._v(" Agregar materiales ")
                          ],
                          1
                        ),
                        _c(
                          "vs-dropdown-menu",
                          { staticClass: "scroll-options" },
                          [
                            _c(
                              "vs-dropdown-item",
                              {
                                staticClass: "dropdown-option",
                                on: { click: _vm.openModalFromUnit }
                              },
                              [_vm._v(" Desde Unidad ")]
                            ),
                            _c(
                              "vs-dropdown-item",
                              {
                                staticClass: "dropdown-option",
                                on: { click: _vm.openModalFromCatalog }
                              },
                              [_vm._v(" Desde Catálogo ")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "row mt-3" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              _vm._l(_vm.selectedEntitiesList, function(entity) {
                return _c(
                  "b-list-group",
                  { key: entity.id },
                  [
                    _c(
                      "b-list-group-item",
                      {
                        key: entity.id,
                        attrs: {
                          "v-b-toggle": "accordion-" + entity.id,
                          button: "",
                          role: "tab"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onActiveAccordion(entity.id)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-11" }, [
                            _vm._v(" " + _vm._s(entity.name) + " ")
                          ]),
                          _c("div", { staticClass: "col-1" }, [
                            _vm.isAccordionOpen &&
                            _vm.activeAccordionId === entity.id
                              ? _c("em", { staticClass: "fa fa-chevron-down" })
                              : _c("em", { staticClass: "fa fa-chevron-up" })
                          ])
                        ])
                      ]
                    ),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "ml-5 mr-5" },
                        [
                          _c(
                            "b-collapse",
                            {
                              attrs: {
                                id: "accordion-" + entity.id,
                                accordion: "my-accordion",
                                role: "tabpanel",
                                block: "",
                                visible:
                                  _vm.isAccordionOpen &&
                                  _vm.activeAccordionId === entity.id
                              }
                            },
                            [
                              _c("b-table", {
                                key: "table-" + entity.id,
                                attrs: {
                                  fixed: "",
                                  responsive: "",
                                  fields: _vm.fieldMaterial,
                                  items: entity.materials,
                                  "sticky-header": "",
                                  id: "table-" + entity.id,
                                  "primary-key": "id"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "cell(SKU)",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(row.item.SKU) + " "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(nombre)",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(row.item.nombre) + " "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(categoria)",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                row.item.categoria[0]
                                                  .descripcion || ""
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(marca)",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                row.item.marca.descripcion
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(cantidad)",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                parseInt(row.item.cantidad)
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(cantidadSolicitar)",
                                      fn: function(row) {
                                        return [
                                          _c("b-form-spinbutton", {
                                            attrs: {
                                              min: "0",
                                              max: "100",
                                              size: "sm"
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.totalRequest(
                                                  row,
                                                  entity
                                                )
                                              }
                                            },
                                            model: {
                                              value: row.item.cantidadSolicitar,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  row.item,
                                                  "cantidadSolicitar",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "row.item.cantidadSolicitar"
                                            }
                                          })
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(precio)",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("toCurrency")(
                                                  parseInt(row.item.precio)
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(total)",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("toCurrency")(
                                                  parseInt(row.item.total)
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "cell(totalSolicitar)",
                                      fn: function(row) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("toCurrency")(
                                                  parseInt(
                                                    row.item.totalSolicitar
                                                  )
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              }),
              1
            )
          ]),
          _vm.enableMaterialsTable
            ? _c("div", [
                _c("div", { staticClass: "row mt-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn",
                          attrs: {
                            size: "md",
                            disabled: !_vm.enableFinishButton
                          },
                          on: { click: _vm.resetMaterials }
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "RefreshCwIcon" }
                          }),
                          _vm._v(" Reiniciar materiales ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-8" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn btn-primary pull-right ml-3",
                          attrs: {
                            size: "md",
                            disabled: !_vm.enableFinishButton
                          },
                          on: { click: _vm.saveChanges }
                        },
                        [
                          _c("feather-icon", { attrs: { icon: "SaveIcon" } }),
                          _vm._v(" Guardar ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "row" }, [
                  !_vm.enableFinishButton
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "font-medium text-primary mr-5 dropdown-option-menu"
                        },
                        [
                          _vm._v(
                            " Debes añadir al menos un material a la solicitud "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            : _vm._e()
        ])
      ]),
      _c("PopUpAddFromUnity", {
        ref: "fromUnityModal",
        on: { reload: _vm.addFromUnity }
      }),
      _c("PopUpAddFromCatalog", {
        ref: "fromCatalogModal",
        on: { reload: _vm.addFromCatalog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }